module.exports = __webpack_public_path__ + "static/img/fuwu2.d67459b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/productAndService/fuwu2.png
// module id = eba1
// module chunks = 1